<template>
  <div class="container-fluid container-wrap col-sm-12 col-xs-12">
    <div class="row justify-content-center">
      <div class="col-sm-12 col-xs-12">
        <div class="card-header pb-0 col-sm-12 d-flex">
          <div class="col-sm-12 col-xs-12">
            <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
              <h3 class="title">전자계약</h3>
              <h5 class="desc">물품 공급 계약, 장비 계약 등 각종 계약을 관리할 수 있습니다.</h5>
            </div>
          </div>
        </div>
        <div class="small-header">
          신규 계약 추가하기
        </div>
        <a-row type="flex" :gutter=30 justify="center">
          <a-col class="col-sm-12 col-xs-12 contract-container">
            <div class="contract-title">
              {{ pageTitle }}
            </div>
            <div class="contract-section-wrap">
              <a-form
                  ref="formRef"
                  :model="formState"
                  :rules="rules"
                  :label-col="labelCol"
                  :wrapper-col="wrapperCol"
                  label-align="left"
                  style="display: flex; flex-direction: column; gap: 8px;"
              >
                <a-typography-title :level="4" style="margin-bottom: 30px">매수인 (고객)</a-typography-title>
                <a-form-item :colon="false" ref="clientName" name="clientName">
                  <template #label>
                    <form-label
                        label-title="고객 상호"
                        :is-required="true"
                    />
                  </template>
                  <a-row>
                    <a-col :span="17">
                      <a-input v-model:value="formState.clientName"
                               placeholder="거래처 검색을 통해 입력해주세요"
                               :disabled="!directInputClient"/>
                    </a-col>
                    <a-col :span="1"></a-col>
                    <a-col :span="2">
                      <a-button
                          class="black"
                          @click="uiHandler.handleModal.client.show">거래처 검색
                      </a-button>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 5px;">
                    <a-checkbox v-model:checked="directInputClient"
                                @change="uiHandler.checkDirectInputClientName">
                      <span style="font-weight: 400">직접입력</span>
                    </a-checkbox>
                  </a-row>
                </a-form-item>
                <a-form-item :colon="false" ref="cNo" name="cNo">
                  <template #label>
                    <form-label
                        label-title="사업자번호"
                        :is-required="true"
                    />
                  </template>
                  <a-input v-model:value="formState.cNo"
                           :disabled="!directInputClient"
                           placeholder="사업자번호를 입력해주세요."/>
                </a-form-item>
                <a-form-item :colon="false" ref="clientManagerName" name="clientManagerName">
                  <template #label>
                    <form-label
                        label-title="성명(예금주)"
                        :is-required="true"
                    />
                  </template>
                  <a-input v-model:value="formState.clientManagerName" placeholder="성명(예금주)를 입력해주세요."/>
                </a-form-item>
                <a-form-item :colon="false" name="ceoBirthDay">
                  <template #label>
                    <form-label
                        label-title="생년월일"
                        :is-required="false"
                    />
                  </template>
                  <a-date-picker
                      :locale="locale"
                      v-model:value="formState.ceoBirthDay"
                      type="date"
                      style="width: 100%"
                  />
                </a-form-item>
                <a-form-item :colon="false" name="installAddress">
                  <template #label>
                    <form-label
                        label-title="설치주소"
                        :is-required="true"
                    />
                  </template>
                  <a-row>
                    <a-col :span="18">
                      <a-textarea class="address ant-like-input customPlaceholder"
                                  placeholder="설치주소를 입력해주세요."
                                  style="height: 80px"
                                  v-model:value="formState.installAddress"/>
                    </a-col>
                    <a-col :span="1"></a-col>
                    <a-col :span="2">
                      <a-button class="black"
                                @click="uiHandler.searchAddress">주소 검색
                      </a-button>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item :colon="false" ref="mobile" name="mobile">
                  <template #label>
                    <form-label
                        label-title="휴대폰 번호"
                        :is-required="true"
                    />
                  </template>
                  <a-input ref="mobileInput" v-model:value="formState.mobile" placeholder="모바일을 입력해주세요."/>
                </a-form-item>
                <a-form-item :colon="false" ref="email" name="email">
                  <template #label>
                    <form-label
                        style="width: 140px;"
                        label-title="세금계산서 수신 이메일"
                        :is-required="false"
                    />
                  </template>
                  <a-input v-model:value="formState.email" placeholder="이메일을 입력해주세요."/>
                  <span style="color: #ACB2B9; font-size: 14px; margin-left: 5px;">세금계산서 발행을 희망할 경우에만 입력해 주세요.</span>
                </a-form-item>
                <a-divider></a-divider>
                <a-typography-title :level="4" style="margin-bottom: 30px">결제정보</a-typography-title>
                <a-form-item :colon="false">
                  <template #label>
                    <form-label
                        label-title="결제방식"
                        :is-required="false"
                    />
                  </template>
                  <a-radio-group v-model:value="formState.selectedPaymentOrg">
                    <a-radio value="card">카드</a-radio>
                    <a-radio value="-">일시납</a-radio>
                  </a-radio-group>
                </a-form-item>
                <a-form-item :colon="false" ref="cardNo" name="cardNo"
                             :is-required="cardPaymentOption"
                             v-if="cardPaymentOption">
                  <template #label>
                    <form-label
                        label-title="카드번호"
                        :is-required="!isOneTimePayment"
                    />
                  </template>
                  <a-input ref="cardNoInput" v-model:value="formState.cardNo"
                           :maxlength="19"
                           placeholder="카드번호를 입력하세요."/>
                  <span style="color: #ACB2B9; font-size: 14px; margin-left: 5px;">국내 신용카드 번호 16자리(또는 15자리)를 입력해주세요.</span>
                </a-form-item>
                <a-form-item :colon="false" name="expiration" ref="expiration" v-if="cardPaymentOption">
                  <template #label>
                    <form-label
                        label-title="유효기간"
                        :is-required="cardPaymentOption"
                    />
                  </template>
                  <a-input ref="expirationInput" v-model:value="formState.expiration"
                           :maxlength="5"
                           placeholder="유효기간을 입력해주세요(MM/YY)"/>
                </a-form-item>
                <a-form-item :colon="false" ref="identificationNo" name="identificationNo"
                             :is-required="cardPaymentOption"
                             v-if="cardPaymentOption">
                  <template #label>
                    <form-label
                        label-title="생년월일"
                        :is-required="!isOneTimePayment"
                    />
                  </template>
                  <a-input v-model:value="formState.identificationNo"
                           placeholder="생년월일을 입력하세요."/>
                  <span style="color: #ACB2B9; font-size: 14px; margin-left: 5px;">법인카드의 경우 사업자등록번호 10자리를 입력해주세요.</span>
                </a-form-item>
                <a-form-item :colon="false" ref="bankCompany" name="bankCompany"
                             v-if="bankPaymentOption">
                  <template #label>
                    <form-label
                        label-title="결제은행"
                        :is-required="bankPaymentOption"
                    />
                  </template>
                  <a-select show-search
                            v-model:value="formState.bankCompany"
                            :notFoundContent="null"
                            placeholder="은행을 선택해 주세요.">
                    <a-select-option
                        v-for="bankCompany in tossBankCompanyList"
                        :key="bankCompany.code"
                        :value="bankCompany.name"
                    >
                      {{ bankCompany.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :colon="false" ref="bankAccount" name="bankAccount" v-if="bankPaymentOption">
                  <template #label>
                    <form-label
                        label-title="결제계좌번호"
                        :is-required="bankPaymentOption"
                    />
                  </template>
                  <a-input v-model:value="formState.bankAccount"
                           placeholder="결제계좌번호를 입력해주세요."/>
                </a-form-item>
                <a-form-item :colon="false" ref="paymentDate" name="paymentDate">
                  <template #label>
                    <form-label
                        label-title="결제일"
                        :is-required="!isOneTimePayment"
                    />
                  </template>
                  <a-select show-search
                            :disabled="isOneTimePayment"
                            :notFoundContent="null"
                            v-model:value="formState.paymentDate">
                    <a-select-option
                        v-for="date in paymentDates"
                        :key="date"
                        :value="date"
                    >
                      {{ date }}일
                    </a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :colon="false" ref="cardCompany" name="cardCompany"
                             v-if="cardPaymentOption">
                  <template #label>
                    <form-label
                        label-title="유효성 검증"
                        :is-required="cardPaymentOption"
                    />
                  </template>
                  <a-row>
                    <a-select disabled
                              class="customPlaceholder"
                              placeholder="카드회사를 선택해주세요"
                              v-model:value="formState.cardCompany">
                      <a-select-option
                          v-for="cardCompany in tossCardCompanyList"
                          :key="cardCompany.code"
                          :value="cardCompany.name"
                      >
                        {{ cardCompany.name }}
                      </a-select-option>
                    </a-select>
                  </a-row>
                  <a-row style="margin-top: 20px;">
                    <a-button class="black"
                              :loading="validateLoading"
                              @click="e => uiHandler.authorizationCard()">검증하기
                    </a-button>
                  </a-row>
                  <a-input style="display: none" v-model:value="passValidation"></a-input>
                  <span style="color: #22BF22" v-if="passValidation">유효성 검사가 완료 되었습니다.</span>
                </a-form-item>
                <a-divider></a-divider>
                <a-typography-title :level="4" style="margin-bottom: 30px">상품정보</a-typography-title>
                <a-form-item :colon="false" name="productName">
                  <template #label>
                    <form-label
                        label-title="상품명"
                        :is-required="true"
                    />
                  </template>
                  <span>ACTILINK reborn</span>
                </a-form-item>
                <a-form-item :colon="false" name="installCount">
                  <template #label>
                    <form-label
                        label-title="설치 대수"
                        :is-required="true"
                    />
                  </template>
                  <a-input-number v-model:value="formState.installCount" :min="1" disabled/>
                </a-form-item>
                <a-form-item :colon="false" name="serialNo" ref="serialNo">
                  <template #label>
                    <form-label label-title="시리얼넘버"/>
                  </template>
                  <a-row type="flex">
                    <a-col :span="17">
                      <a-input v-if="directInputSerialNo" v-model:value="formState.serialNo"/>
                      <a-select show-search
                                v-else
                                mode="multiple"
                                :max-tag-count=1
                                @change="uiHandler.onProductCodeSelect"
                                :disabled="!directSelectSerialNo"
                                v-model:value="formState.serialNo">
                        <template #notFoundContent>
                          {{ $t('noresult_search') }}
                        </template>
                        <a-select-option
                            v-for="productCode in actiLinkProducts"
                            :key="productCode"
                            :value="productCode"
                        >
                        </a-select-option>
                      </a-select>
                    </a-col>
                    <a-col :span="1"></a-col>
                    <a-col :span="5">
                      <a-button class="black"
                                @click="uiHandler.handleModal.hospitalPayment.show">불러오기
                      </a-button>
                    </a-col>
                  </a-row>
                  <a-row style="margin-top: 5px;">
                    <a-col :span="6">
                      <a-checkbox v-model:checked="directSelectSerialNo"
                                  @change="uiHandler.checkDirectSelectSerialNo">
                        <span style="font-weight: 400">직접선택</span>
                      </a-checkbox>
                    </a-col>
                    <a-col :span="6">
                      <a-checkbox v-model:checked="directInputSerialNo"
                                  @change="uiHandler.checkDirectInputSerialNo">
                        <span style="font-weight: 400">직접입력</span>
                      </a-checkbox>
                    </a-col>
                  </a-row>
                </a-form-item>
                <a-form-item :colon="false" name="rentalFee">
                  <template #label>
                    <form-label
                        style="width: 150px"
                        :label-title="paymentStr"
                        :is-required="true"
                    />
                  </template>
                  <a-row>
                    <a-input style="width: 120px"
                             v-model:value="formState.rentalFee"
                             v-on:input="uiHandler.formatRentalFee()"/>
                  </a-row>
                </a-form-item>
                <a-form-item :colon="false" name="contractMonth">
                  <template #label>
                    <form-label
                        label-title="약정월"
                        :is-required="false"
                    />
                  </template>
                  <a-select v-model:value="formState.contractMonthCount" placeholder="약정 월을 선택하세요">
                    <a-select-option value="36개월">36개월</a-select-option>
                    <a-select-option value="48개월">48개월</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :colon="false" name="installFee">
                  <template #label>
                    <form-label
                        label-title="설치 등록비"
                        :is-required="true"
                    />
                  </template>
                  <a-input style="width: 120px"
                           v-model:value="formState.installFee"
                           v-on:input="uiHandler.formatInstallFee()"/>
                </a-form-item>
                <a-form-item :colon="false" name="contractDate">
                  <template #label>
                    <form-label
                        label-title="계약일"
                        :is-required="true"
                    />
                  </template>
                  <a-date-picker
                      :locale="locale"
                      v-model:value="formState.contractDate"
                      type="date"
                      style="width: 100%"
                  />
                </a-form-item>
                <a-form-item :colon="false" ref="contractManager" name="contractManager"
                >
                  <template #label>
                    <form-label
                        label-title="계약담당자"
                        :is-required="true"
                    />
                  </template>
                  <a-input v-if="directInputContractManager" v-model:value="formState.contractManager"
                           placeholder="계약담당자를 입력해주세요."/>
                  <a-select v-else v-model:value="formState.contractManager"
                            @change="uiHandler.selectContractManager">
                    <a-select-option
                        v-for="contractManager in contractManagerList"
                        :key="contractManager.mobile"
                        :value="contractManager.name"
                    >
                    </a-select-option>
                  </a-select>
                  <a-row style="margin-top: 5px;">
                    <a-checkbox v-model:checked="directInputContractManager"
                                @change="uiHandler.checkDirectInputContractManager">
                      <span style="font-weight: 400">직접입력</span>
                    </a-checkbox>
                  </a-row>
                </a-form-item>
                <a-form-item :colon="false" ref="contractManagerMobile"
                             name="contractManagerMobile">
                  <template #label>
                    <form-label
                        style="width: 140px;"
                        label-title="계약담당자 전화번호"
                        :is-required="true"
                    />
                  </template>
                  <a-input v-model:value="formState.contractManagerMobile" placeholder="알림톡을 수신할 연락처를 입력해주세요."/>
                </a-form-item>
              </a-form>
            </div>
            <div class="contract-footer">
              <a-button
                  @click="async (e) => {
                     const isConfirmed = await twoBtnDialog(`안내`, `작성중인 계약서가 있습니다. 페이지를 떠나시겠습니까?`, '확인');
                     if (isConfirmed) {
                        $router.push(contractTypesPath)
                     }
                  }"
              >
                취소
              </a-button>
              <a-button
                  type="primary"
                  @click="uiHandler.handleModal.contractDraftModal.show"
              >
                미리보기
              </a-button>
              <a-button
                  class="contract-submit-btn btn-hover"
                  @click="(uiHandler.createTempContract)"
                  style="font-weight: 700;"
              >
                계약서 임시저장
              </a-button>
              <a-button
                  type="primary"
                  @click="uiHandler.onSubmit"
                  style="font-weight: 700;"
              >
                계약서 작성 완료
              </a-button>
            </div>
          </a-col>
          <a-col></a-col>
          <a-col class="col-sm-12 col-xs-12 contract-container is-desktop-only">
            <div class="contract-title" style="position: relative; z-index: 100; background-color: white;">
              {{ pageTitle }} 미리보기
              <LottieAnimation
                  v-if="previewLoading"
                  :animation-data="loadingAnimation"
                  :auto-play="true"
                  :loop="true"
                  :speed="1"
                  class="lottie-player-component loading-img"
                  ref="anim"
              />
              <a-button v-else type="primary" @click="uiHandler.makeContractDraft">
                <i class="fa-solid fa-rotate-right"></i><span style="margin-left: 5px">새로고침</span>
              </a-button>
            </div>
            <div class="iframe-wrap">
              <iframe :src=modal.contractDraft.embeddedUrl class="preview-iframe" style="height: 1930px; position: relative; top: -52px;"></iframe>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
  <!--  모달-->
  <search-client-modal
      :show-modal="modal.client.show"
      :init-data-load="false"
      @close-modal="uiHandler.handleModal.client.close"
      @complete-search="uiHandler.handleModal.client.handleEvent.selectClient"
  />
  <search-address-modal
      :show-modal="modal.address.show"
      @close-modal="uiHandler.handleModal.address.close"
      @complete-search="uiHandler.handleModal.address.handleEvent.selectAddress"
  />
  <summary-contract-modal
      :show-modal="modal.summary.show"
      :summary-contents="summary"
      @summary-confirm="uiHandler.handleModal.summary.handleEvent.summaryConfirm"
      @close-modal="uiHandler.handleModal.summary.close"
  />
  <create-contract-success-modal-v3
      :show-modal="modal.createSuccess.show"
      :secure-link-param="secureLinkParam"
      @close-modal="uiHandler.handleModal.createSuccess.close"
  />
  <contract-draft-modal
      :show-modal="modal.contractDraft.show"
      :embedded-url="modal.contractDraft.embeddedUrl"
      @close-modal="uiHandler.handleModal.contractDraftModal.close"
  />
  <hospital-payment-modal
      :data-source="hospitalRentalList"
      :show-modal="modal.hospitalPayment.show"
      @close-modal="uiHandler.handleModal.hospitalPayment.close"
      @complete-select="uiHandler.handleModal.hospitalPayment.handleEvent.selectHospitalRental"
  />
</template>
<script>
import {defineComponent} from "vue";
import ContractItemWrap from "@/views/ContractManagement/components/ContractItemWrap.vue";
// v3: 계약 생성·미리보기·임시저장은 contracts-api. 부속 2건(ACTILINK 제품 목록
// /products/actilink/reborns, 카드 인증 /contracts/check/card)은 contracts-api 에 대응
// 라우트가 없어 v1($apiInstance) 핸들러를 병행한다 — SearchClientModal 등과 같은 경계 판단.
// v1 완전 은퇴 시 이 두 라우트의 이관이 선행돼야 한다.
import contractApi from "@/views/ContractManagementV3/api";
import v1ContractApi from "@/views/ContractManagement/api";
import contractsApiInstance from "@/contractsApi";
import {resolveContractCreateRouteName} from "@/views/ContractManagementV3/routeMap";
import {businessNumberFormatter, logging, oneBtnDialog, phoneNumberFormatter, twoBtnDialog} from "@/utils/utils";
import {LottieAnimation} from "lottie-web-vue";
import loadingAnimation from "@/assets/img/loading.json";
import 'dayjs/locale/ko'
import locale from 'ant-design-vue/es/date-picker/locale/ko_KR';
import ContractDraftModal from "@/views/ContractManagement/components/ContractDraftModal.vue";
import SummaryContractModal from "@/views/ContractManagement/components/SummaryContractModal.vue";
import dayjs from "dayjs";
import SearchClientModal from "@/views/ContractManagement/components/SearchClientModal.vue";
import SearchAddressModal from "@/views/ContractManagement/components/SearchAddressModal.vue";
import CreateContractSuccessModalV3 from "@/views/ContractManagementV3/components/CreateContractSuccessModalV3.vue";
import FormLabel from "@/views/components/FormLabel.vue";
import HospitalPaymentModal from "@/views/SubscriptionManagement/plasmapp/HospitalPaymentModal.vue";
import {ContractTypeEnum} from "@/views/ContractManagement/enums";
import {validateContractClientNameLength} from "@/views/ContractManagement/contracts/contractValidationUtils";

import {CONTRACT_TYPES_PATH} from '@/utils/contractConsole';
export default defineComponent({
  // v3 라우트 name = routeMap 단일 매핑(v1 name + 'V3'). 라우트 등록과 동일 값 보장.
  name: resolveContractCreateRouteName('ACTILINK 정기 렌탈서비스 약정서'),
  components: {
    HospitalPaymentModal,
    CreateContractSuccessModalV3,
    SearchClientModal,
    SummaryContractModal,
    ContractDraftModal,
    ContractItemWrap,
    LottieAnimation,
    FormLabel,
    SearchAddressModal
  },
  props: {
    templateId: {
      type: String,
      required: true,
    }
  },
  mounted() {
    this.uiHandler.init()
  },
  computed: {
    limitedLengthYY: {
      get() {
        return this.formState.expiration.yy;
      },
      set(value) {
        if (value.length <= 2) {
          this.formState.expiration.yy = value;
        }
      }
    },
    limitedLengthMM: {
      get() {
        return this.formState.expiration.mm;
      },
      set(value) {
        if (value.length <= 2) {
          this.formState.expiration.mm = value;
        }
      },
    },
    cardPaymentOption() {
      return this.formState.selectedPaymentOrg === 'card'
    },
    bankPaymentOption() {
      return this.formState.selectedPaymentOrg === 'bank'
    },
    tossCardCompanyList() {
      // https://docs.tosspayments.com/reference/codes#%EC%B9%B4%EB%93%9C%EC%82%AC-%EC%BD%94%EB%93%9C
      return [
        {name: "기업BC", code: "3K", ko: "기업비씨", eng: "IBK_BC"},
        {name: "광주은행", code: "46", ko: "광주", eng: "GWANGJUBANK"},
        {name: "롯데카드", code: "71", ko: "롯데", eng: "LOTTE"},
        {name: "KDB산업은행", code: "30", ko: "산업", eng: "KDBBANK"},
        {name: "BC카드", code: "31", ko: "-", eng: "BC"},
        {name: "삼성카드", code: "51", ko: "삼성", eng: "SAMSUNG"},
        {name: "새마을금고", code: "38", ko: "새마을", eng: "SAEMAUL"},
        {name: "신한카드", code: "41", ko: "신한", eng: "SHINHAN"},
        {name: "신협", code: "62", ko: "신협", eng: "SHINHYEOP"},
        {name: "씨티카드", code: "36", ko: "씨티", eng: "CITI"},
        {name: "우리BC카드 (BC 매입)", code: "33", ko: "우리", eng: "WOORI"},
        {name: "우리카드 (우리 매입)", code: "W1", ko: "우리", eng: "WOORI"},
        {name: "우체국예금보험", code: "37", ko: "우체국", eng: "POST"},
        {name: "저축은행중앙회", code: "39", ko: "저축", eng: "SAVINGBANK"},
        {name: "전북은행", code: "35", ko: "전북", eng: "JEONBUKBANK"},
        {name: "제주은행", code: "42", ko: "제주", eng: "JEJUBANK"},
        {name: "카카오뱅크", code: "15", ko: "카카오뱅크", eng: "KAKAOBANK"},
        {name: "케이뱅크", code: "3A", ko: "케이뱅크", eng: "KBANK"},
        {name: "토스뱅크", code: "24", ko: "토스뱅크", eng: "TOSSBANK"},
        {name: "하나카드", code: "21", ko: "하나", eng: "HANA"},
        {name: "현대카드", code: "61", ko: "현대", eng: "HYUNDAI"},
        {name: "KB국민카드", code: "11", ko: "국민", eng: "KOOKMIN"},
        {name: "NH농협카드", code: "91", ko: "농협", eng: "NONGHYEOP"},
        {name: "Sh수협은행", code: "34", ko: "수협", eng: "SUHYEOP"},
        {name: "페이코", code: "-", ko: "-", eng: "PCP"},
        {name: "KB증권", code: "-", ko: "-", eng: "KBS"},
      ]
    },
    tossBankCompanyList() {
      // https://docs.tosspayments.com/reference/codes#%EC%9D%80%ED%96%89-%EC%BD%94%EB%93%9C
      return [
        {name: "경남은행", official_code: "039", code: "39", ko: "경남", eng: "KYONGNAMBANK"},
        {name: "광주은행", official_code: "034", code: "34", ko: "광주", eng: "GWANGJUBANK"},
        {name: "단위농협(지역농축협)", official_code: "012", code: "12", ko: "단위농협", eng: "LOCALNONGHYEOP"},
        {name: "부산은행", official_code: "032", code: "32", ko: "부산", eng: "BUSANBANK"},
        {name: "새마을금고", official_code: "045", code: "45", ko: "새마을", eng: "SAEMAUL"},
        {name: "산림조합", official_code: "064", code: "64", ko: "산림", eng: "SANLIM"},
        {name: "신한은행", official_code: "088", code: "88", ko: "신한", eng: "SHINHAN"},
        {name: "신협", official_code: "048", code: "48", ko: "신협", eng: "SHINHYEOP"},
        {name: "씨티은행", official_code: "027", code: "27", ko: "씨티", eng: "CITI"},
        {name: "우리은행", official_code: "020", code: "20", ko: "우리", eng: "WOORI"},
        {name: "우체국예금보험", official_code: "071", code: "71", ko: "우체국", eng: "POST"},
        {name: "저축은행중앙회", official_code: "050", code: "50", ko: "저축", eng: "SAVINGBANK"},
        {name: "전북은행", official_code: "037", code: "37", ko: "전북", eng: "JEONBUKBANK"},
        {name: "제주은행", official_code: "035", code: "35", ko: "제주", eng: "JEJUBANK"},
        {name: "카카오뱅크", official_code: "090", code: "90", ko: "카카오", eng: "KAKAOBANK"},
        {name: "케이뱅크", official_code: "089", code: "89", ko: "케이", eng: "KBANK"},
        {name: "토스뱅크", official_code: "092", code: "92", ko: "토스", eng: "TOSSBANK"},
        {name: "하나은행", official_code: "081", code: "81", ko: "하나", eng: "HANA"},
        {name: "홍콩상하이은행", official_code: "054", code: "54", ko: "-", eng: "HSBC"},
        {name: "IBK기업은행", official_code: "003", code: "03", ko: "기업", eng: "IBK"},
        {name: "KB국민은행", official_code: "004", code: "06", ko: "국민", eng: "KOOKMIN"},
        {name: "DGB대구은행", official_code: "031", code: "31", ko: "대구", eng: "DAEGUBANK"},
        {name: "KDB산업은행", official_code: "002", code: "02", ko: "산업", eng: "KDBBANK"},
        {name: "NH농협은행", official_code: "011", code: "11", ko: "농협", eng: "NONGHYEOP"},
        {name: "SC제일은행", official_code: "023", code: "23", ko: "SC제일", eng: "SC"},
        {name: "Sh수협은행", official_code: "007", code: "07", ko: "수협", eng: "SUHYEOP"},
      ]
    },
    paymentDates() {
      return [5]
    },
    paymentStr() {
      if (this.isOneTimePayment) {
        return '일시납 렌탈료(VAT포함)'
      } else {
        return '월 렌탈료(VAT포함)'
      }
    }
  },
  watch: {
    'formState.selectedPaymentOrg': function (newValue) {
      if (newValue === '-') {
        this.formState.cardCompany = '-'
        this.formState.cardNo = '-'
        this.formState.expiration = '-'
        this.formState.paymentDate = ['-']
        this.formState.rentalFee = this.baseOnetimePayment
        this.formState.installFee = 0
        this.formState.contractMonthCount = "-"
        this.isOneTimePayment = true
      } else {
        this.formState.cardCompany = null
        this.formState.expiration = null
        this.formState.cardNo = null
        this.formState.bankCompany = null
        this.formState.bankAccount = null
        this.formState.paymentDate = "5일"
        this.formState.rentalFee = this.baseRentalFee
        this.formState.installFee = this.baseInstallFee
        this.formState.contractMonthCount = '36개월'
        this.isOneTimePayment = false
      }
    },
    'formState.mobile': {
      handler: function (newVal, oldVal) {
        const cleanVal = newVal.replace(/\D/g, '');

        // Maximum length check
        if (cleanVal.length > 11) {
          this.formState.mobile = oldVal;
          return;
        }

        this.formState.mobile = phoneNumberFormatter(cleanVal);
      },
      immediate: true,
      deep: true
    },
    'formState.cNo': {
      handler: function (newVal, oldVal) {
        const cleanVal = newVal.replace(/\D/g, '');

        // Maximum length check
        if (cleanVal.length > 10) {
          this.formState.cNo = oldVal;
          return;
        }

        this.formState.cNo = businessNumberFormatter(cleanVal);
      },
      immediate: true,
      deep: true
    },
    'formState.rentalFee': {
      handler: function (newVal, oldVal) {
        this.formState.rentalFee = newVal.toLocaleString();
      },
      immediate: true,
      deep: true
    },
    'formState.installFee': {
      handler: function (newVal, oldVal) {
        this.formState.installFee = newVal.toLocaleString();
      },
      immediate: true,
      deep: true
    },
    'formState.contractManagerMobile': {
      handler: function (newVal, oldVal) {
        const cleanVal = newVal.replace(/\D/g, '');

        // Maximum length check
        if (cleanVal.length > 11) {
          this.formState.contractManagerMobile = oldVal;
          return;
        }

        this.formState.contractManagerMobile = phoneNumberFormatter(cleanVal);
      },
      immediate: true,
      deep: true
    },
  },
  data() {
    const uiHandler = this.ui();
    const loginUser = JSON.parse(localStorage.getItem("CompanyInfo"))["accountInfo"]
    const baseRentalFee = 99000
    const baseInstallFee = 0
    const baseOnetimePayment = 3990000
    return {
      locale,
      previewLoading: false,
      loadingAnimation,
      pageTitle: this.$route.query.name ?? '',
      contractType: ContractTypeEnum.ACTILINK,
      contractTitle: 'ACTILINK 정기 렌탈서비스 약정서',
      uiHandler,
      apiHandler: this.api(),
      contractTypesPath: CONTRACT_TYPES_PATH,
      v1ApiHandler: v1ContractApi(this.$apiInstance, this.$store), // 부속 2건 전용(상단 주석)
      formRef: null,
      labelCol: {span: 7},
      wrapperCol: {offset: 2, span: 17},
      rawHospitalData: null,
      directInputClient: false,
      directInputContractManager: false,
      directSelectSerialNo: false,
      directInputSerialNo: false,
      contractManagerList: [],
      secureLinkParam: {
        contractId: '',
        participantId: '',
      },
      actiLinkProducts: [],
      hospitalRentalList: [],
      loginUser,
      baseRentalFee,
      baseInstallFee,
      baseOnetimePayment,
      isOneTimePayment: false,
      validateLoading: false,
      passValidation: false,
      formState: {
        clientName: "",
        cNo: "",
        clientManagerName: "",
        ceoBirthDay: undefined,
        installAddress: "",
        mobile: "",
        email: "",
        selectedPaymentOrg: "card",
        cardCompany: null,
        cardNo: null,
        identificationNo: null,
        expiration: null,
        bankCompany: null,
        bankAccount: null,
        paymentDate: '5일',
        serialNo: [],
        contractMonthCount: '36개월',
        installCount: 1,
        rentalFee: baseRentalFee,
        installFee: baseInstallFee,
        contractDate: null,
        contractManager: loginUser.name,
        contractManagerMobile: loginUser.mobile
      },
      rawValue: '',
      displayValue: '',
      focused: false,
      rules: {
        clientName: [
          {
            required: true,
            validator: uiHandler.validateClientName,
            trigger: 'change',
          }
        ],
        cNo: [
          {
            required: true,
            validator: uiHandler.validateCno,
            trigger: 'change',
          }
        ],
        clientManagerName: [
          {
            required: true,
            message: '예금주명을 입력해주세요.',
            trigger: 'blur',
          }
        ],
        installAddress: [
          {
            required: true,
            message: '설치주소를 입력해주세요.',
            trigger: 'change',
          }
        ],
        installCount: [
          {
            required: true,
            validator: uiHandler.validateInstallCount,
            trigger: 'change',
          }
        ],
        mobile: [
          {
            required: true,
            validator: uiHandler.validateMobile,
            trigger: 'change',
          }
        ],
        email: [
          {
            required: false,
            validator: uiHandler.validateEmailFormat,
            trigger: 'change',
          }
        ],
        cardCompany: [
          {
            required: !this.isOneTimePayment,
            message: '유효성 검사를 진행해주세요.',
            trigger: 'change',
          }
        ],
        cardNo: [
          {
            required: !this.isOneTimePayment,
            validator: uiHandler.validateCardNumber,
            trigger: 'change',
          }
        ],
        identificationNo: [
          {
            required: !this.isOneTimePayment,
            message: '생년월일을 입력해주세요.(YYMMDD)',
            trigger: 'change',
          }
        ],
        expiration: [
          {
            required: !this.isOneTimePayment,
            validator: uiHandler.validateExpiration,
            trigger: 'change'
          }
        ],
        paymentDate: [
          {
            required: !this.isOneTimePayment,
            message: '결제일을 입력해주세요.',
            trigger: 'change',
          }
        ],
        contractDate: [
          {
            required: true,
            message: '계약일을 입력해주세요.',
            trigger: 'change',
          }
        ],
        contractManager: [
          {
            required: true,
            message: '계약담당자를 입력해주세요.',
            trigger: 'blur',
          }
        ],
        contractManagerMobile: [
          {
            required: true,
            message: '계약담당자 전화번호를 입력해주세요.',
            trigger: 'change',
          }
        ],
        serialNo: [
          {
            required: false,
            message: '제품코드를 선택해주세요.',
            trigger: 'change',
          }
        ],
      },

      summary: {
        "계약명": "",
        "병원명": "",
        "병원장명": "",
        "병원 주소": "",
        "병원 연락처": "",
        "총 계약 금액": "",
      },
      modal: {
        client: {
          show: false
        },
        address: {
          show: false
        },
        summary: {
          show: false,
        },
        createSuccess: {
          show: false,
        },
        contractDraft: {
          embeddedUrl: '',
          show: false
        },
        hospitalPayment: {
          show: false
        }
      },
    }
  },
  methods: {
    twoBtnDialog,
    ui() {
      const getEpochTimeFromDate = (dateString) => {
        if (!dateString) return 0;
        return dayjs(dateString, 'YYYY-MM-DD');
      }
      const makeContractParam = () => {
        const contractDateToken = this.formState.contractDate ? dayjs(this.formState.contractDate).format('YYYY-MM-DD').split("-") : " - -"
        let contract = {
          paymentDate: !this.isOneTimePayment && this.formState.paymentDate ? this.formState.paymentDate.toString().replace('일', '') : "",
          installCount: this.formState.installCount,
          rentalFee: parseInt(this.formState.rentalFee.replace(/,/g, '')),
          installFee: parseInt(this.formState.installFee.replace(/,/g, '')),
          contractYear: contractDateToken[0],
          contractMonth: contractDateToken[1],
          contractDate: contractDateToken[2],
          serialNo: this.formState.serialNo,
          isOneTimePayment: this.isOneTimePayment ? 'Y' : 'N',
          contractMonthCount: this.isOneTimePayment ? 0 : this.formState.contractMonthCount?.replace("개월", ""),
          cardIdentificationNo: this.formState.identificationNo
        };

        console.log("11===>", contract)

        if (this.cardPaymentOption) {
          // 카드 관련 정보가 있는 경우
          contract.cardCompany = this.isOneTimePayment ? "" : this.formState.cardCompany || "";
          contract.cardNo = this.isOneTimePayment ? "" : this.formState.cardNo || "";
          contract.identificationNo = this.isOneTimePayment ? "" : this.formState.identificationNo || "";
          contract.validationDate = this.isOneTimePayment ? "" : this.formState.expiration || "";
          contract.bankCompany = ""
          contract.bankAccount = ""
        } else if (this.bankPaymentOption) {
          // 은행 관련 정보가 있는 경우
          contract.cardCompany = "";
          contract.cardNo = "";
          contract.validationDate = "";
          contract.bankCompany = this.isOneTimePayment ? "" : this.formState.bankCompany || "";
          contract.bankAccount = this.isOneTimePayment ? "" : this.formState.bankAccount || "";
        }
        return {
          templateId: this.templateId,
          contractCreator: this.contractCreator,
          contractType: this.contractType,
          contractTitle: this.contractTitle,
          clientInfos: [
            {
              name: this.formState.clientName,
              bizNo: this.formState.cNo,
              manager: this.formState.clientManagerName,
              ceoBirthDay: dayjs(this.formState.ceoBirthDay).format('YYYY-MM-DD'),
              installAddress: this.formState.installAddress,
              mobile: this.formState.mobile,
              email: this.formState.email,
            }
          ],
          seller: {
            manager: this.formState.contractManager.trim(),
            mobile: this.formState.contractManagerMobile.trim()
          },
          contract
        }
      }
      const createContract = async () => {
        await this.apiHandler.createContract(
            makeContractParam(),
            // 24/02/01 배포이후 항상 SECURE_LINK 로 생성
            async (response) => {
              this.secureLinkParam = {
                contractId: response.data.id,
                participantId: response.data.participants[0]?.id,
              }
              this.uiHandler.handleModal.createSuccess.show()
            }, async (error) => {
              await oneBtnDialog('계약 추가 실패', '신규 계약서 작성에 실패하였습니다.', false);
            }
        )
      }
      return {
        init: async () => {
          await this.uiHandler.getManufacturerAccounts();
          await this.uiHandler.makeContractDraft();
          await this.uiHandler.loadTempContract();
        },
        getManufacturerAccounts: async () => {
          await this.apiHandler.getManufacturerAccounts((response) => {
            const managers = [
              {method: "select", name: this.loginUser.name, mobile: this.loginUser.mobile},
              {method: "select", name: "김원식", mobile: "010-8883-6936"},
              {method: "select", name: "송창훈", mobile: "010-2939-2243"},
              {method: "select", name: "홍유동", mobile: "010-4245-4520"},
            ]
            const managersFromApi = response.data.docs.map(d => {
              return {method: 'select', name: d.name, mobile: d.mobile}
            })

            let combinedArray = [...managers, ...managersFromApi];

            this.contractManagerList = Array.from(new Set(combinedArray.map(a => a.name)))
                .map(name => {
                  return combinedArray.find(a => a.name === name)
                });
          }, async (error) => {
            await oneBtnDialog('계약담당자 로딩 실패', '계약담당자 목록 로딩에 실패하였습니다.', false);
          })
        },
        checkDirectInputClientName: (e) => {
          this.formState.clientName = ''
          this.formState.cNo = ''
          this.formState.clientManagerName = ''
          this.formState.installAddress = ''

          this.directInputClient = e.target.checked
        },
        checkDirectInputContractManager: async (e) => {
          if (e.target.checked) {
            this.formState.contractManager = ''
            this.formState.contractManagerMobile = ' '
          } else {
            this.formState.contractManager = this.contractManagerList[0].name
            this.formState.contractManagerMobile = this.contractManagerList[0].mobile
            await this.$refs.formRef.validateFields(['contractManager']);
          }

          this.directInputContractManager = e.target.checked
        },
        checkDirectSelectSerialNo: async (e) => {
          this.directSelectSerialNo = e.target.checked
          this.directInputSerialNo = false;
          if (this.directSelectSerialNo) {
            await this.v1ApiHandler.getActiLinkProducts(async (response) => {
              this.actiLinkProducts = response.data.map(p => p.productCode)
              this.formState.serialNo = response.data[0]?.productCode
              this.formState.installCount = 1
              if (this.isOneTimePayment) {
                this.formState.rentalFee = this.baseOnetimePayment
              } else {
                this.formState.rentalFee = this.baseRentalFee
              }
              await this.$refs.formRef.validateFields(['serialNo']);
            }, async (error) => {
              await oneBtnDialog('상품 로딩 실패', 'ACTILINK 상품 로딩에 실패하였습니다.', false);
            })
          } else {
            this.formState.serialNo = []
          }
        },
        checkDirectInputSerialNo: async (e) => {
          this.directSelectSerialNo = false
          this.directInputSerialNo = e.target.checked
          if (this.directInputSerialNo) {
            this.formState.serialNo = [""]
            this.formState.installCount = 1
            if (!this.isOneTimePayment) {
              this.formState.rentalFee = this.baseRentalFee
            }
            await this.$refs.formRef.validateFields(['serialNo']);
          } else {
            this.formState.serialNo = []
          }
        },
        validateExpiration: (_rule, value) => {
          if (this.isOneTimePayment) {
            return Promise.resolve();
          }

          if (!value) {
            this.uiHandler.scrollOnError('expiration')
            return Promise.reject(new Error('유효기간을 입력해주세요(MM/YY)'));
          }

          if (value.replace("/", "").length > 4) {
            return Promise.reject(new Error('유효기간은 4자리 숫자여야 합니다.'));
          }

          let month = parseInt(value.replace("/", "").substring(0, 2));
          let year = parseInt(value.replace("/", "").substring(2));

          if (isNaN(month) || month < 1 || month > 12) {
            return Promise.reject(new Error('월은 01에서 12 사이의 숫자여야 합니다.'));
          }

          if (isNaN(year) || year < 24) {
            return Promise.reject(new Error('년은 24 이상의 숫자여야 합니다.'));
          }

          if (month < 10) {
            this.formState.expiration = `0${month}/${year}`;
          } else {
            this.formState.expiration = `${month}/${year}`;
          }

          return Promise.resolve();
        },
        validateEmailFormat: (_rule, value) => {
          if (!value) {
            return Promise.resolve();
          }

          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

          if (!emailPattern.test(value)) {
            return Promise.reject(new Error('유효한 이메일 형식을 입력해주세요.'));
          }
          return Promise.resolve();
        },
        validateClientName: (_rule, value) => {
          if (!value) {
            this.uiHandler.scrollOnError('clientName')
            return Promise.reject(new Error('고객상호를 입력해주세요.'));
          }
          return Promise.resolve();
        },
        validateCno: async (_rule, value) => {
          if (!value) {
            this.uiHandler.scrollOnError('cNo')
            return Promise.reject(new Error('사업자번호를 입력해주세요.'));
          }
          return Promise.resolve();
        },
        validateMobile: (_rule, value) => {
          if (!value) {
            this.uiHandler.scrollOnError('mobile')
            return Promise.reject(new Error('전화번호를 입력해주세요.'));
          }
          return Promise.resolve();
        },
        validateInstallCount: (_rule, value) => {
          if (value < 1) {
            return Promise.reject(new Error('설치 대수는 최소 1대 이상 선택해주세요.'));
          }
          return Promise.resolve();
        },
        validateCardNumber: (_rule, value) => {
          if (!value) {
            this.uiHandler.scrollOnError('cardNo');
            return Promise.reject(new Error('카드번호를 입력해주세요.'));
          }

          let numberOnly = value?.replace(/-/g, '');

          // 아메리칸 익스프레스 카드 번호 포맷 (4-6-5)
          if (numberOnly.startsWith('37') || numberOnly.startsWith('34')) {
            const parts = [
              numberOnly.slice(0, 4),
              numberOnly.slice(4, 10),
              numberOnly.slice(10, 15),
            ];
            this.formState.cardNo = parts.join('-').slice(0, 15 + 2); // 추가된 하이픈 두 개를 고려
          } else {
            // Visa, MasterCard 등 (4-4-4-4)
            if ([4, 8, 12, 16].includes(numberOnly.length)) {
              numberOnly = numberOnly.replace(/(\d{4})(?=\d)/g, '$1-');
              this.formState.cardNo = numberOnly;
            }
          }

          if (numberOnly.length > 19) {
            return Promise.reject(new Error('카드번호는 15 또는 16자리여야 합니다.'));
          }

          return Promise.resolve();
        },
        phoneNumberFormatter,
        makeContractDraft: async () => {
          this.previewLoading = true
          // 거래처 상호 길이 가드: 미리보기/초안 자동생성 경로 (modusign metadata 80자 제한)
          // 자동 호출 경로이므로 모달 금지 — API 호출 skip만 (인라인 에러 영역 없음, 제출 경로에서 안내됨)
          const _previewClientNameCheck = validateContractClientNameLength({
            name: this.formState.clientName,
            manager: this.formState.clientManagerName,
            mobile: this.formState.mobile,
          });
          if (!_previewClientNameCheck.ok) {
            this.previewLoading = false;
            return;
          }
          await this.apiHandler.createContractDraft(
              makeContractParam(),
              async (response) => {
                this.modal.contractDraft.embeddedUrl = `${response?.data?.embeddedUrl}&mode=preview`;
              }, async (error) => {
                await oneBtnDialog('계약 초안 생성 실패', '신규 계약서 초안 생성에 실패하였습니다.', false);
              }
          ).finally(() => this.previewLoading = false)
        },
        selectContractManager: (value, option) => {
          console.log('===>', value)
          console.log('===>', option)
          this.formState.contractManagerMobile = option.key
        },
        authorizationCard: async () => {
          if (!this.formState.cNo) {
            try {
              await this.$refs.formRef.validateFields(['clientName', 'cNo', 'clientManagerName', 'installAddress', 'mobile']);
            } catch (validationError) {
            }
            return;
          }
          if (!this.formState.mobile) {
            try {
              await this.$refs.formRef.validateFields(['mobile']);
            } catch (validationError) {
            }
            return;
          }

          if (!this.formState.cardNo) {
            try {
              await this.$refs.formRef.validateFields(['cardNo']);
            } catch (validationError) {
            }
            return;
          }

          if (!this.formState.expiration) {
            try {
              await this.$refs.formRef.validateFields(['expiration']);
            } catch (validationError) {
            }
            return;
          }

          if (!this.formState.identificationNo) {
            try {
              await this.$refs.formRef.validateFields(['identificationNo']);
            } catch (validationError) {
            }
            return;
          }

          this.validateLoading = true
          await this.v1ApiHandler.authorizationCard({
            cNo: this.formState.cNo,
            cardNo: this.formState.cardNo,
            expiration: this.formState.expiration,
            identificationNo: this.formState.identificationNo
          }, async (response) => {
            try {
              this.formState.cardCompany = response.data
              this.passValidation = true
              await this.$refs.formRef.validateFields(['cardCompany']);
            } catch (validationError) {
              console.log("cardCompany===>", validationError)
            }
          }, async (error) => {
            await oneBtnDialog('카드 검증 실패', error.response.data.message)
          }).finally(() => this.validateLoading = false)
        },
        onSubmit: async () => {
          if (!this.formState.mobile) {
            try {
              await this.$refs.formRef.validateFields(['mobile']);
            } catch (validationError) {
            }
            return;
          }

          if (!this.formState.cardNo) {
            try {
              await this.$refs.formRef.validateFields(['cardNo']);
            } catch (validationError) {
            }
            return;
          }

          if (!this.formState.expiration) {
            try {
              await this.$refs.formRef.validateFields(['expiration']);
            } catch (validationError) {
            }
            return;
          }

          // 거래처 상호 길이 검증 (modusign metadata 80자 제한)
          const clientNameCheck = validateContractClientNameLength({
            name: this.formState.clientName,
            manager: this.formState.clientManagerName,
            mobile: this.formState.mobile,
          });
          if (!clientNameCheck.ok) {
            await oneBtnDialog('거래처 상호 길이 초과', clientNameCheck.message, false);
            return;
          }

          this.$refs.formRef.validate().then(() => {
            console.log('values', this.formState, JSON.parse(JSON.stringify(this.formState)));
            this.summary = {
              계약명: this.contractTitle,
              병원명: `${this.formState.clientName} (${this.formState.cNo ? this.formState.cNo : '거래처 직접 입력 - 사업자등록번호 발급전 입니다.'})`,
              병원장명: this.formState.clientManagerName,
              "병원 주소": `${this.formState.installAddress}`,
              // "병원 연락처": `(유선전화) ${this.clientData.contact.phone}/(휴대전화) ${this.clientData.contact.mobile}/(이메일) ${this.clientData.contact.email}`,
              "병원 연락처": `(휴대전화) ${this.formState.mobile}`,
              "월 렌탈 금액": `${parseInt(this.formState.rentalFee.replace(/,/g, '')).toLocaleString()} ${this.isOneTimePayment ? '(일시납)' : ''}`,
              "약정 개월 수": this.formState.contractMonthCount
            }
            this.modal.summary.show = true
          }).catch(error => {
            console.error('error', error)
          })
        },
        resetForm: async () => {
          this.$refs.formRef.resetFields()
        },
        searchAddress: () => {

          this.modal.address.show = true;
          setTimeout(() => {
            if (document.querySelector('.search-client-body iframe') === null) {
              new daum.Postcode({
                width: window.innerWidth * 0.8 > 550 ? 550 : window.innerWidth * 0.8,
                height: window.innerWidth * 0.8 > 550 ? 550 : window.innerWidth * 0.8,
                oncomplete: (data) => {
                  let addr = '';                          // 주소 변수
                  if (data.userSelectedType === 'R') {    // 사용자가 도로명 주소를 선택했을 경우
                    addr = data.roadAddress;
                  } else {                                // 사용자가 지번 주소를 선택했을 경우(J)
                    addr = data.jibunAddress;
                  }
                  this.formState.installAddress = addr?.replace(/undefined/g, '');
                  this.modal.address.show = false;
                }
              }).embed(document.querySelector('.search-client-body'));
            }
          }, 200);
        },
        formatRentalFee: () => {
          let value = this.formState.rentalFee;
          value = value.replace(/,/g, '');
          value = parseFloat(value);
          if (value < 0) {
            value = 0;
          }
          if (isNaN(value) || value < 0) {
            value = 0;
          }
          this.formState.rentalFee = value.toLocaleString();
        },
        formatInstallFee: () => {
          let value = this.formState.installFee;
          value = value.replace(/,/g, '');
          value = parseFloat(value);
          if (value < 0) {
            value = 0;
          }
          if (isNaN(value) || value < 0) {
            value = 0;
          }
          this.formState.installFee = value.toLocaleString();
        },
        handleModal: {
          client: {
            show: () => {
              this.uiHandler.checkDirectInputClientName({
                target: {
                  checked: false
                }
              })
              this.modal.client.show = true
            },
            close: () => this.modal.client.show = false,
            handleEvent: {
              selectClient: async (client) => {
                this.rawHospitalData = client;
                logging().exceptProd("this.rawHospitalData===>", this.rawHospitalData)
                this.formState.cNo = businessNumberFormatter(client.cNo);
                this.formState.clientName = client.name;
                this.formState.clientManagerName = client.ceo;
                this.formState.installAddress = `${client.addrOne} ${client.addrTwo} ${client.addrThree} ${client.addrDetail}`?.replace(/undefined/g, '');
                this.modal.client.show = false;

                // 유효성 검사 다시 수행
                await this.$refs.formRef.validateFields(['clientName', 'cNo', 'clientManagerName', 'installAddress']);
              }
            }
          },
          address: {
            show: () => {
              this.modal.address.show = true
            },
            close: () => this.modal.address.show = false,
            handleEvent: {
              selectAddress: async (address) => {
                this.modal.address.show = false;
              }
            }
          },
          summary: {
            show: async () => {
              // if (!await validateData()) return;
              this.summary = {
                계약명: this.contractTitle,
                병원명: `${this.formState.clientName}`,
                병원장명: this.formState.clientManagerName,
                "병원 주소": `${this.formState.installAddress}`,
                "병원 연락처": `(휴대전화) ${this.formState.mobile}`,
                "총 계약 금액": this.baseRentalFee
              }
              this.modal.summary.show = true
            },
            close: () => this.modal.summary.show = false,
            handleEvent: {
              summaryConfirm: async (childPassParam) => {
                await createContract();
              }
            }
          },
          createSuccess: {
            show: () => {
              this.modal.summary.show = false;
              this.modal.createSuccess.show = true
            },
            close: () => this.modal.createSuccess.show = false,
          },
          contractDraftModal: {
            show: async () => {
              this.$store.commit('setIsLoading', true);
              await this.uiHandler.makeContractDraft();
              this.modal.contractDraft.show = true
              this.$store.commit('setIsLoading', false);
            },
            close: () => this.modal.contractDraft.show = false
          },
          hospitalPayment: {
            show: async () => {
              this.directSelectSerialNo = false
              this.directInputSerialNo = false
              this.formState.serialNo = []

              if (!this.rawHospitalData?.cNo) {
                await oneBtnDialog('안내', '거래처 검색 이후에 불러오기를 진행해주세요.')
                return
              }
              if (this.hospitalRentalList.length === 0) {
                await oneBtnDialog('안내', '선택한 거래처에 아직 정기 렌탈 내역이 없습니다. 시리얼넘버를 직접입력 해주세요')
                this.formState.serialNo = []
                this.formState.rentalFee = this.baseRentalFee
                this.formState.installCount = 1
                return
              }
              this.$store.commit('setIsLoading', true);
              this.modal.hospitalPayment.show = true;
              this.$store.commit('setIsLoading', false);
            },
            close: async () => {
              this.modal.hospitalPayment.show = false
            },
            handleEvent: {
              selectHospitalRental: async (item) => {
                logging().exceptProd("selectHospitalRental====>", item)
                this.formState.serialNo = item.productCodes
                this.formState.installCount = item.productCodes.length
                this.formState.rentalFee = this.baseRentalFee * item.productCodes.length
                await this.$refs.formRef.validateFields(['serialNo']);
                this.modal.hospitalPayment.show = false;
              }
            }
          }
        },
        onProductCodeSelect: (key, option) => {
          logging().exceptProd("===>", key)
          logging().exceptProd("===>", option)
          this.formState.installCount = key.length
          this.formState.rentalFee = this.baseRentalFee * key.length
        },
        scrollOnError: (name) => {
          const ref = this.$refs[name];
          if (!ref) return;

          const sections = {
            firstSection: [{name: 'clientName'}, {name: 'cNo'}, {name: 'clientManagerName'}, {name: 'installAddress'}, {name: 'mobile', moveType: 'focus'}],
            secondSection: [{name: 'cardNo', moveType: 'focus'}, {name: 'expiration', moveType: 'focus'}],
          };

          let targetFraction;

          if (Object.values(sections).flat().map(f => f.name).includes(name)) {
            if (sections.firstSection.map(f => f.name).includes(name)) {
              targetFraction = 1 / 3;
            } else if (sections.secondSection.map(s => s.name).includes(name)) {
              targetFraction = 2 / 3;
            } else {
              targetFraction = 1;
            }
          } else {
            return;
          }

          const allSections = Object.values(sections).flat();
          const section = allSections.find(item => item.name === name);

          if (section?.moveType === 'focus') {
            const refInput = this.$refs[`${name}Input`];
            if (refInput && refInput.focus) {
              refInput.focus();
            } else {
              console.warn('The element cannot be focused:', refInput);
            }
          } else {
            window.scrollTo({
              top: window.innerHeight * targetFraction,
              behavior: 'smooth'
            });
          }
        },
        createTempContract: async (e) => {
          // 거래처 상호 길이 검증 (modusign metadata 80자 제한)
          const clientNameCheck = validateContractClientNameLength({
            name: this.formState.clientName,
            manager: this.formState.clientManagerName,
            mobile: this.formState.mobile,
          });
          if (!clientNameCheck.ok) {
            await oneBtnDialog('거래처 상호 길이 초과', clientNameCheck.message, false);
            return;
          }
          const confirm = await twoBtnDialog('안내', '계약서를 임시저장 하시겠습니까?', '저장')
          if (confirm) {
            await this.apiHandler.createTempContract({
              contractType: this.contractType,
              payload: {
                ...makeContractParam(),
                directInputClient: this.directInputClient,
                directSelectSerialNo: this.directSelectSerialNo,
                directInputSerialNo: this.directInputSerialNo
              }
            }, (response) => {
              console.log("create temp contract==>", response)
            }, (error) => {
              console.log("create temp contract==>", error)
            })
          }
        },
        loadTempContract: async () => {
          await this.apiHandler.getTempContract({
            contractType: this.contractType,
          }, async (result) => {
            const {payload} = result
            if (payload) {
              const confirm = await twoBtnDialog('안내', '임시저장된 계약서 내용이 있습니다. 불러오시겠습니까?', '확인')
              if (confirm) {
                const clientInfo = payload.clientInfos[0]
                const seller = payload.seller
                const contract = payload.contract

                // 병원정보
                this.formState.clientName = clientInfo.name
                this.formState.cNo = clientInfo.bizNo
                this.formState.clientManagerName = clientInfo.manager
                if ( clientInfo.ceoBirthDay !== 'Invalid Date' && clientInfo.ceoBirthDay) {
                  this.formState.ceoBirthDay = getEpochTimeFromDate(clientInfo.ceoBirthDay)
                }
                this.formState.installAddress = clientInfo.installAddress
                this.formState.mobile = clientInfo.mobile
                this.formState.email = clientInfo.email
                this.directInputClient = payload.directInputClient
                // 계약담당자 정보
                this.formState.contractManagerMobile = seller.mobile
                this.formState.contractManager = seller.manager
                // 계약 정보
                if (contract.contractYear.replace("-", "").trim()
                    && contract.contractMonth.replace("-", "").trim()
                    && contract.contractDate.replace("-", "").trim()) {
                  this.formState.contractDate = getEpochTimeFromDate(`${contract.contractYear}-${contract.contractMonth}-${contract.contractDate}`)
                }
                this.isOneTimePayment = contract.isOneTimePayment === 'Y'
                this.formState.serialNo = contract.serialNo
                this.formState.installCount = contract.installCount
                this.formState.rentalFee = contract.rentalFee.toLocaleString('en-US')
                this.formState.installFee = contract.installFee.toLocaleString('en-US')
                this.formState.selectedPaymentOrg = this.isOneTimePayment ? '-' : 'card'
                this.formState.cardNo = contract.cardNo
                this.formState.expiration = contract.validationDate
                this.formState.contractMonthCount = contract.contractMonthCount
                this.formState.identificationNo = contract.cardIdentificationNo
                this.directInputSerialNo = payload.directInputSerialNo
                this.directSelectSerialNo = payload.directSelectSerialNo
                // 계약서 미리보기에 반영하기
                await this.uiHandler.makeContractDraft()
              }
            }
          }, (err) => {
            console.log("get temp contract error==>", err);
          })
        }
      }
    },
    api() {
      return contractApi(contractsApiInstance, this.$store)
    },
  }
})
</script>

<style>
@media screen and (max-width: 767px) {
  .ant-col-offset-2 {
    margin-left: 0 !important;
  }
}
</style>
<style scoped lang="scss">
@import '@/assets/scss/contract-detail.scss';
</style>
